export default {
  label: {
    field: 'Field',
    groupingBy: 'Grouping by',
    none: 'None',
  },
};
